<template>
  <v-card>
    <v-container grid-list-md pa-0>
      <v-layout row>
        <v-flex grow py-0>
          <v-card-title class="headline">{{ component.title }}</v-card-title>
        </v-flex>
        <v-flex shrink py-0>
          <v-btn icon @click="$emit('closing')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="component.type !== 'footer' && component.previews.length > 1">
        <v-flex xs12 py-0>
          <p>View more options and possibilities for the {{ component.title }} below. {{ component.description }}</p>
          <p v-if="component.packages.length > 0" class="package-note"><span class="material-icons">verified</span>&nbsp;Included in the Sokal {{ component.packages[0] }} website package</p>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="card-img">
            <v-img class="primary-img" width="100%" :src="currentImage" alt="Component Preview"></v-img>
            <div v-if="component.type !== 'footer' && component.previews.length > 1" class="actions">
              <span @click="prevImage" class="prev">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </span>
              <span @click="nextImage" class="next">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-3 v-if="component.type !== 'footer' && component.previews.length > 1">
        <v-flex md3 pt-2 v-for="(preview, index) in component.previews" :key="preview.id">
          <a @click="activateImage(index)">
            <v-img class="secondary-img" :src="preview.image" alt="Component Preview"></v-img>
          </a>
        </v-flex>
      </v-layout>
      <v-btn depressed class="modal-btn" @click="addComponent($event), $emit('closing'), $emit('choosed')">Add Component</v-btn>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
props: ['component', 'chosen'],
data() {
    return {
      activeImage: 0
    }
  },
computed: {
  ...mapGetters(
      ['chosenArray', 'imagePreview']
  ),
  currentImage() {
    if (this.component.type !== 'footer' && this.component.previews.length > 1) {
      return this.component.previews[this.activeImage].image;
    } else {
      return this.imagePreview(this.component);
    }
  },
  componentLength() {
    return this.component.previews.length
  }
},
methods: {
  addComponent() {
    this.$store.state.chosenComponents.push(this.component);
  },
  changeSelection(preview) {
    this.selection = preview.image;
  },
  nextImage() {
    var active = this.activeImage + 1;
    if(active >= this.componentLength) {
        active = 0;
    }
    this.activateImage(active);
  },
  prevImage() {
    var active = this.activeImage - 1;
    if(active < 0) {
        active = this.componentLength - 1;
    }
    this.activateImage(active);
  },
  activateImage(imageIndex) {
      this.activeImage = imageIndex;
  }
}
}
</script>

<style scoped>
.secondary-img {
  cursor: pointer;
  border: 1px solid rgba(0, 106, 255, .35);
  border-radius: 3px;
}
.v-dialog .v-card {
  padding: 15px 30px;
  font-size: 15px;
}
.v-dialog .v-card .v-card__title {
  padding-left: 0px;
}
.modal-btn {
  margin-left: 0px;
  background: #006aff !important;
  color: #fff;
  border: 2px solid #006aff !important;
  font-size: 16px;
  font-weight: 500;
}
.modal-btn:hover {
  background: #fff !important;
  color: #006aff;
}
.card-img {
  position: relative;
  border: 2px solid rgba(0, 106, 255, .35);
  border-radius: 3px;
}
.card-img .actions {
  position: absolute;
  top: 50%;
  color: #fff;
  width: 100%;
}
.card-img .actions span {
  position: absolute;
  font-size: 24px;
  cursor: pointer;
  text-shadow: 1px 3px 5px rgba(0 0 0 / 40%);
}
.card-img .actions .prev {
  left: 10px;
}
.card-img .actions .next {
  right: 10px;
}
.package-note .material-icons {
  color: #006aff;
  font-size: 20px;
  position: relative;
  top: 4px;
}
</style>
